import './report-list.scss'

import { ConditionReportState } from '@skinsoft/types'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { SearchHeader } from '@skinsoft/search/src/search-header'
import { ReportFeaturedList, TitleClickAction } from '@skinsoft/ui'
import Component from 'vue-class-component'

declare const CONDITION_REPORTS_SORTING_ENTITY_FIELDS: any[]

@Component({
    components: {
        sReportFeaturedList: ReportFeaturedList,
        sSearchHeader: SearchHeader
    },
    props: ['listState', 'titleI18NKey', 'targetRouteName', 'titleClickAction'],
    template: require('./report-list.html')
})
export class ReportList extends ReactiveVue {

    public listState: ConditionReportState;
    public titleI18NKey: string;
    private titleClickAction: TitleClickAction

    private nbReports: string = "";
    private sortingEntityFields: any[] = [];

    public mounted() {
        this.$on('nb-fetched-reports-topic', (message) => {
            this.nbReports = this.$t('listReportScreen.nbResults', { nbResults: message.nbReports }) as string;
        })
        this.sortingEntityFields = CONDITION_REPORTS_SORTING_ENTITY_FIELDS;
    }
}